import { defineMessages } from 'react-intl';

export const i18n: {
	noCreatePermissionsErrorTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noCreatePermissionsErrorDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	permissionsErrorTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	permissionsErrorDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	parentChildLoopErrorTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	parentChildLoopErrorDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	singleConflictingTitleRenameErrorTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	singleConflictingTitleRenamePageErrorDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	singleConflictingTitleRenameContentErrorDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	renameFailedErrorDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	newTitleLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	singleConflictingPageNameWithinEditorErrorCallToAction: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	singleConflictingLivePageNameWithinEditorErrorCallToAction: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	singleConflictingPageNameWithinEditorErrorTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	singleConflictingLivePageNameWithinEditorErrorTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	singleConflictingPageNameWithinEditorErrorDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	singleConflictingLiveDocNameWithinEditorErrorDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	multipleConflictingContentNamesErrorTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	multipleConflictingContentNamesErrorDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	restrictionsPermissionErrorTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	restrictionsPermissionErrorDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	destinationDoesNotExistErrorTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	destinationDoesNotExistErrorDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sourceDoesNotExistErrorTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sourceDoesNotExistErrorDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	draftPermissionsErrorTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	draftPermissionsErrorDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	draftWithChildrenErrorTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	draftWithChildrenErrorDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	defaultErrorTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	defaultErrorDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tooManyPagesErrorTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tooManyPagesErrorDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	moreThan100PagesErrorTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	moreThan100PagesErrorDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	movingContentToSelfErrorTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	movingContentToSelfErrorDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	currentlyUpdatedErrorTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	currentlyUpdatedErrorDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	partiallyMovedErrorTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	partiallyMovedErrorDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	notSpaceAdminForCrossSpaceMoveTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	notSpaceAdminForCrossSpaceMoveDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	noCreatePermissionsErrorTitle: {
		id: 'page-tree.move-page-dialog.published-page.move-error.no-create-permissions-error.title',
		defaultMessage: 'You can’t move this content',
		description:
			"The error title when a user can't move their content to the selected location because they cannot create content in the selected space",
	},

	noCreatePermissionsErrorDescription: {
		id: 'page-tree.move-page-dialog.published-page.move-error.no-create-permissions-error.description',
		defaultMessage:
			'To move content to another space, you need permission to create in that space.',
		description:
			"The error description when a user can't move their page to the selected location because they cannot create pages in the selected space",
	},

	permissionsErrorTitle: {
		id: 'page-tree.move-page-dialog.published-page.move-error.permissions-error.title',
		defaultMessage: 'You don’t have permission to move this content',
		description:
			"The error title when a user can't move their content to the selected location because they don't have the required permissions",
	},

	permissionsErrorDescription: {
		id: 'page-tree.move-page-dialog.published-page.move-error.permissions-error.description',
		defaultMessage:
			'Contact a space admin to get the content moved or to give you the permissions you need.',
		description:
			"The error description when a user can't move their page to the selected location because they don't have the required permissions",
	},

	parentChildLoopErrorTitle: {
		id: 'page-tree.move-page-dialog.published-page.move-error.parent-child-loop.title',
		defaultMessage: 'Select a different destination',
		description:
			"The error title when a user can't move their content to the selected parent because the selected parent is a child of their content",
	},

	parentChildLoopErrorDescription: {
		id: 'page-tree.move-page-dialog.published-page.move-error.parent-child-loop.description',
		defaultMessage: 'The destination cannot be nested below the content being moved.',
		description:
			"The error description when a user can't move their content to the selected parent because the selected parent is a child of their content",
	},

	singleConflictingTitleRenameErrorTitle: {
		id: 'page-tree.move-page-dialog.published-page.move-error.single-conflicting-title-rename.title',
		defaultMessage: 'Rename this content to move it',
		description:
			"The title of the info section message shown when a user can't move their content to the selected space because the space already contains a single content with the same name, and they can rename and retry inline",
	},

	singleConflictingTitleRenamePageErrorDescription: {
		id: 'page-tree.move-page-dialog.published-page.move-error.single-conflicting-title-rename.page-description',
		defaultMessage: `A page with this title already exists in <strong>{destinationSpace}</strong>. We’ll rename it for you so you can move it.`,
		description:
			"The description of the info section message shown when a user can't move their page to the selected space because the space already contains a page with the same title, and they can rename and retry inline",
	},

	singleConflictingTitleRenameContentErrorDescription: {
		id: 'page-tree.move-page-dialog.published-page.move-error.single-conflicting-title-rename.content-description',
		defaultMessage: `Content with this title already exists in <strong>{destinationSpace}</strong>. We’ll rename it for you so you can move it.`,
		description:
			"The description of the info section message shown when a user can't move their content to the selected space because the space already contains content with the same title, and they can rename and retry inline",
	},

	renameFailedErrorDescription: {
		id: 'page-tree.move-page-dialog.published-page.move-error.rename-failed.description',
		defaultMessage: 'Try a different title, then move it again.',
		description: 'The error description shown when the inline rename-before-move action fails',
	},

	newTitleLabel: {
		id: 'page-tree.move-page-dialog.published-page.move-error.single-conflicting-title-rename.new-title-label',
		defaultMessage: 'New title',
		description:
			'Label for the text input where the user edits the suggested new title before moving',
	},

	singleConflictingPageNameWithinEditorErrorCallToAction: {
		id: 'page-tree.move-page-dialog.published-page.move-error.single-conflicting-page-name-within-editor.call-to-action',
		defaultMessage: `Rename this page`,
		description:
			"Text that will be in a button, that when clicked will redirect the user back to the editor to rename their page because the space they are trying to move content to already contains a single page with their page's name",
	},

	singleConflictingLivePageNameWithinEditorErrorCallToAction: {
		id: 'page-tree.move-page-dialog.published-page.move-error.single-conflicting-live-page-name-within-editor.call-to-action',
		defaultMessage: `Rename this doc`,
		description:
			"Text that will be in a button, that when clicked will redirect the user back to the editor to rename their live page because the space they are trying to move content to already contains a single live page with their live page's name",
	},

	singleConflictingPageNameWithinEditorErrorTitle: {
		id: 'page-tree.move-page-dialog.published-page.move-error.single-conflicting-page-name-within-editor.title',
		defaultMessage: 'Rename this page to make it unique',
		description:
			"The error title when a user can't move their page group to the selected space because the space already contains a single page with their page's name",
	},

	singleConflictingLivePageNameWithinEditorErrorTitle: {
		id: 'page-tree.move-page-dialog.published-page.move-error.single-conflicting-live-page-name-within-editor.title',
		defaultMessage: 'Rename this doc to make it unique',
		description:
			"The error title when a user can't move their live page group to the selected space because the space already contains a single live page with their live page's name",
	},

	singleConflictingPageNameWithinEditorErrorDescription: {
		id: 'page-tree.move-page-dialog.published-page.move-error.single-conflicting-page-name-within-editor.description',
		defaultMessage: `A page titled <strong>{conflictingPageName}</strong> already exists in the {destinationSpace} space. To move this page, you’ll first need to give it a unique title and publish it.`,
		description:
			"The error description when a user can't move their page group to the selected space because the space already contains a single page with their page's name",
	},

	singleConflictingLiveDocNameWithinEditorErrorDescription: {
		id: 'page-tree.move-page-dialog.live-doc.move-error.single-conflicting-page-name-within-editor.description',
		defaultMessage: `There’s already a live doc named <strong>{conflictingPageName}</strong> in {destinationSpace}. Give this doc a unique title to move it.`,
		description:
			"The error description when a user can't move their live page group to the selected space because the space already contains a single live page with their live page's name",
	},

	multipleConflictingContentNamesErrorTitle: {
		id: 'page-tree.move-page-dialog.published-page.move-error.multiple-conflicting-page-name.title',
		defaultMessage: 'Content with these names already exist',
		description:
			"The error title when a user can't move their page group to the selected space because the space already contains multiple pages with their page's name",
	},

	multipleConflictingContentNamesErrorDescription: {
		id: 'page-tree.move-page-dialog.published-page.move-error.multiple-conflicting-page-name.description',
		defaultMessage:
			'The following content already exists in the {destinationSpace} space: {listOfConflictingNames}. Rename your content before moving.',
		description:
			"The error description when a user can't move their page group to the selected space because the space already contains multiple pages with their page's name",
	},

	restrictionsPermissionErrorTitle: {
		id: 'page-tree.move-page-dialog.published-page.move-error.no-restrictions-permissions.title',
		defaultMessage: 'You can’t move restricted content to this space',
		description:
			"The error title when a user can't move their content to the selected space because their content has restrictions and they do not have permissions " +
			'to set restrictions in the selected space',
	},

	restrictionsPermissionErrorDescription: {
		id: 'page-tree.move-page-dialog.published-page.move-error.no-restrictions-permissions.description',
		defaultMessage:
			'This content is restricted, and you don’t have permission to create restricted content in the new space. Remove restrictions before moving it.',
		description:
			"The error description when a user can't move their page to the selected space because their page has restrictions and they do not have permissions " +
			'to set restrictions in the selected space',
	},

	destinationDoesNotExistErrorTitle: {
		id: 'page-tree.move-page-dialog.published-page.move-error.destination-does-not-exist.title',
		defaultMessage: 'Select a different destination',
		description:
			'The error title when the user selects a move destination that was deleted or archived after the user opened the move dialog.',
	},

	destinationDoesNotExistErrorDescription: {
		id: 'page-tree.move-page-dialog.published-page.move-error.destination-does-not-exist.description',
		defaultMessage:
			'This destination has recently been deleted or archived. Please select a different destination.',
		description:
			'The error description when the user selects a move destination that was deleted or archived after the user opened the move dialog.',
	},

	sourceDoesNotExistErrorTitle: {
		id: 'page-tree.move-page-dialog.published-page.move-error.source-does-not-exist.title',
		defaultMessage: 'This content can’t be moved',
		description:
			'The error title when the user selects a source content to move that was deleted or archived after the user opened the move dialog.',
	},

	sourceDoesNotExistErrorDescription: {
		id: 'page-tree.move-page-dialog.published-page.move-error.source-does-not-exist.description',
		defaultMessage:
			'This content has recently been deleted or archived and therefore cannot be moved.',
		description:
			'The error description when the user selects a source page to move that was deleted or archived after the user opened the move dialog.',
	},

	draftPermissionsErrorTitle: {
		id: 'page-tree.move-page-dialog.draft-page.move-error.default.title',
		defaultMessage: 'You can’t move this content',
		description: 'Error message for drafts to the selected location',
	},

	draftPermissionsErrorDescription: {
		id: 'page-tree.move-page-dialog.draft-page.move-error.default.description',
		defaultMessage:
			'Only the owner can move a draft to another space. Contact them or a space admin for help.',
		description:
			'Error message shown when unpublished drafts can’t be moved to another space due to insufficient permissions. Only draft owners can move drafts to another space',
	},

	draftWithChildrenErrorTitle: {
		id: 'page-tree.move-page-dialog.draft-page.children.move-error.default.title',
		defaultMessage: 'You can’t move this content',
		description: 'Error message for drafts to the selected location',
	},

	draftWithChildrenErrorDescription: {
		id: 'page-tree.move-page-dialog.draft-page.children.move-error.default.description',
		defaultMessage:
			'This draft has children and cannot be moved to another space. Move them first to relocate this draft or contact a space admin for help.',
		description:
			'Error message shown when unpublished drafts can’t be moved to another space because they have children (should be uncommon)',
	},

	defaultErrorTitle: {
		id: 'page-tree.move-page-dialog.published-page.move-error.default.title',
		defaultMessage: 'We’re having issues moving this content',
		description:
			"General error title when a user can't move their content to the selected location",
	},

	defaultErrorDescription: {
		id: 'page-tree.move-page-dialog.published-page.move-error.default.description',
		defaultMessage:
			'We’re having issues moving this content. Refresh and try again; if that doesn’t solve the issue, please contact support.',
		description:
			"General error description when a user can't move their content to the selected location",
	},

	tooManyPagesErrorTitle: {
		id: 'page-tree.move-page-dialog.published-page.move-error.too-many-pages.title',
		defaultMessage: 'We couldn’t move this many items at once.',
		description:
			'The error title when the user is trying to move more pages than the server can handle',
	},

	tooManyPagesErrorDescription: {
		id: 'page-tree.move-page-dialog.published-page.move-error.too-many-pages.description',
		defaultMessage: 'Try again by selecting an item with fewer child items.',
		description:
			'The error description when the user is trying to move more pages than the server can handle',
	},

	moreThan100PagesErrorTitle: {
		id: 'page-tree.move-page-dialog.published-page.move-error.more-than-hundred-pages.title',
		defaultMessage: 'We couldn’t move this many items at once.',
		description:
			'The error title when the user is trying to move more pages than the server can handle',
	},

	moreThan100PagesErrorDescription: {
		id: 'page-tree.move-page-dialog.published-page.move-error.more-than-hundred-pages.description',
		defaultMessage: 'Try again by selecting an item with fewer than 100 child items.',
		description:
			'The error description when the user is trying to move more pages than the server can handle',
	},

	movingContentToSelfErrorTitle: {
		id: 'page-tree.move-page-dialog.published-page.move-error.source-same-as-target.title',
		defaultMessage: 'You can’t move any content to a position relative to itself',
		description:
			'Specific move error title where the target of any move operation is the same as source',
	},

	movingContentToSelfErrorDescription: {
		id: 'page-tree.move-page-dialog.published-page.move-error.source-same-as-target.description',
		defaultMessage:
			'Uh, oh! You are attempting to move content to itself. Please choose other content you wish to move to.',
		description:
			'Specific move error description where the target of any move operation is the same as source',
	},

	currentlyUpdatedErrorTitle: {
		id: 'page-tree.move-page-dialog.published-page.move-error.currently-updated.title',
		defaultMessage: 'We can’t move this content right now',
		description:
			"Title of the error message shown when the content can't be moved because someone else updated the content at the exact same instant the user tried to move the content",
	},

	currentlyUpdatedErrorDescription: {
		id: 'page-tree.move-page-dialog.published-page.move-error.currently-updated.description',
		defaultMessage: 'Someone just updated this content. Refresh and try moving it again.',
		description:
			"Error message shown when the content can't be moved because someone else updated the content at the exact same instant the user tried to move the content",
	},

	partiallyMovedErrorTitle: {
		id: 'page-tree.move-page-dialog.published-page.move-error.partially-moved.title',
		defaultMessage: 'The move could not be fully completed',
		description:
			'Title of the error message shown when some of the content failed to be moved due to an error and was not able to be rolled back to the original space',
	},

	partiallyMovedErrorDescription: {
		id: 'page-tree.move-page-dialog.published-page.move-error.partially-moved.description',
		defaultMessage:
			'Some of the content was not able to be moved to the target space. If you have trouble finding any content, please reach out to Support for help.',
		description:
			'Error message shown when some of the content failed to be moved due to an error and was not able to be rolled back to the original space',
	},

	notSpaceAdminForCrossSpaceMoveTitle: {
		id: 'page-tree.move-page-dialog.published-page.move-error.not-space-admin-cross-space.title',
		defaultMessage: 'You can’t move this content',
		description:
			'Error message shown when content can’t be moved to another space due to insufficient permissions. Only space administrators can move content to another space',
	},

	notSpaceAdminForCrossSpaceMoveDescription: {
		id: 'page-tree.move-page-dialog.published-page.move-error.not-space-admin-cross-space.description',
		defaultMessage:
			'Only space admins can move content to another space. Contact your admin for help.',
		description:
			'Error message shown when content can’t be moved to another space due to insufficient permissions. Only space administrators can move content to another space',
	},
});
